/**
 * Custom hook for fetching dashboard data
 */
import { useState, useEffect, useCallback } from 'react';
import dashboardService from '../services/dashboardService';

export const useDashboard = () => {
  const [stats, setStats] = useState(null);
  const [recentProjects, setRecentProjects] = useState([]);
  const [projectStages, setProjectStages] = useState([]);
  const [commandCenter, setCommandCenter] = useState(null);
  const [riskQueue, setRiskQueue] = useState({ items: [], total: 0, counts: {} });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const [statsData, projectsData, stagesData, commandCenterData, riskQueueData] = await Promise.all([
        dashboardService.getStats(),
        dashboardService.getRecentProjects(),
        dashboardService.getProjectStages(),
        dashboardService.getCommandCenter(),
        dashboardService.getRiskQueue(),
      ]);
      
      setStats(statsData);
      setRecentProjects(projectsData);
      setProjectStages(stagesData);
      setCommandCenter(commandCenterData);
      setRiskQueue(riskQueueData || { items: [], total: 0, counts: {} });
    } catch (err) {
      setError(err.message || 'Failed to load dashboard data');
      console.error('Dashboard fetch error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return {
    stats,
    recentProjects,
    projectStages,
    commandCenter,
    riskQueue,
    loading,
    error,
    refresh: fetchDashboardData,
  };
};

export default useDashboard;
